import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'font-awesome/css/font-awesome.css';
import 'froala-editor/js/froala_editor.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';

import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import Delete from 'material-ui/svg-icons/action/delete';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import FroalaEditor from 'react-froala-wysiwyg';
import {handleApiError} from '../../shared/services';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import {List} from 'immutable';
import MenuItem from 'material-ui/MenuItem';
import muiTheme from '../../../styles/teamologyTheme';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import toastr from 'toastr';
import Toggle from 'material-ui/Toggle';
import {
  addMaterialSupply,
  deleteMaterialSupply,
  loadCharacterDropdowns,
  setAddPostForm,
  submitAddPostForm,
  updateAddMaterialMenuIsOpen,
  updateMaterialFileNames,
  updateMaterialSupply,
  updatePhotoNames,
} from '../actions';
import {browserHistory, withRouter} from 'react-router';
import {
  Card,
  CardActions,
  CardText,
} from 'material-ui/Card';
import {FileUploader, TextInput} from '../../shared/components';
import {loadGrades, loadLessonPlanTypes, loadSubjects} from '../../shared/actions';
import React, {Component, PropTypes} from 'react';

class AddPostForm extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentWillMount() {
    this.materialFiles = [];
    this.photos = [];
  }

  componentDidMount() {
    const {loadCharacterDropdowns, loadGrades, loadLessonPlanTypes, loadSubjects} = this.props;
    loadCharacterDropdowns();
    loadGrades();
    loadLessonPlanTypes();
    loadSubjects();
  }

  callUpdateMaterialFileNames() {
    const materialFileNames = this.materialFiles.map(f => f.name);
    this.props.updateMaterialFileNames(materialFileNames);
  }

  callUpdatePhotoNames() {
    const photoNames = this.photos.map(p => p.name);
    this.props.updatePhotoNames(photoNames);
  }

  handleSubmitClick(event) {
    event.preventDefault();

    const {handleSubmit, model, router, userId, onSubmitSuccess} = this.props;
    const formattedModel = {
      title: model.get('title'),
      lessonType: model.get('lessonPlanType'),
      content: model.get('content'),
      characterId: model.get('characterId'),
      gradeIds: model.get('gradeIds').toJS(),
      schoolwide: model.get('schoolwide'),
      homeCommunity: model.get('homeCommunity'),
      userId,
      materials: this.materialFiles,
      supplies: model.getIn(['materials', 'supplies']).toJS(),
      photos: this.photos,
      featuredImage: this.featuredImageFile,
      subjectId: model.get('subjectId'),
    };

    handleSubmit(formattedModel)
      .then(result => {
        onSubmitSuccess();
        toastr.success('Success.', 'Your content has been added', {timeout: 10000, allowHtml: true});
        browserHistory.push(`/pending/lesson/${result.value.data.id}`);
      })
      .catch(error => {
        // 413 - Request Entity Too Large
        if (error.response.status === 413) {
          handleApiError(error, router, 'File is too large.', 'Error');
        } else {
          handleApiError(error, router, 'An error occurred while attempting to add your content.', 'Error');
        }
      });
  }

  handleFieldChange(event) {
    const {name, value} = event.target;
    this.props.setAddPostForm(name, value);
  }

  handleCharacterChange(event, index, value) {
    this.props.setAddPostForm('characterId', value);
  }

  handleGradeChange(event, index, values) {
    this.props.setAddPostForm('gradeIds', values);
  }

  handleLessonPlanTypeChange(event, index, value) {
    this.props.setAddPostForm('lessonPlanType', value);
  }

  handleFeaturedImageChange(files) {
    if (files.length) {
      this.featuredImageFile = files[0];
      this.props.setAddPostForm('featuredImageName', this.featuredImageFile.name);
    }
  }

  handleResetFeaturedImage() {
    this.featuredImageFile = {name: ''};
    this.props.setAddPostForm('featuredImageName', '');
  }

  handleContentChange(content) {
    this.props.setAddPostForm('content', content);
  }

  handleSchoolwideToggle() {
    const {setAddPostForm, model} = this.props;
    setAddPostForm('schoolwide', !model.get('schoolwide'));
    setAddPostForm('homeCommunity', false);
  }

  handleHomeCommunityToggle() {
    const {setAddPostForm, model} = this.props;
    setAddPostForm('homeCommunity', !model.get('homeCommunity'));
    setAddPostForm('schoolwide', false);
  }

  handleAddPhoto() {
    this.photos.push({name: ''});
    this.callUpdatePhotoNames();
  }

  handlePhotoChange(files, index) {
    if (files.length) {
      this.photos[index] = files[0];
      this.callUpdatePhotoNames();
    }
  }

  handleDeletePhoto(index) {
    this.photos.splice(index, 1);
    this.callUpdatePhotoNames();
  }

  handleAddFileMaterial() {
    this.materialFiles.push({name: ''});
    this.callUpdateMaterialFileNames();
  }

  handleMaterialFileChange(files, index) {
    if (files.length) {
      this.materialFiles[index] = files[0];
      this.callUpdateMaterialFileNames();
    }
  }

  handleDeleteMaterialFile(index) {
    this.materialFiles.splice(index, 1);
    this.callUpdateMaterialFileNames();
  }

  handleAddMaterialIconTouchTap() {
    const {updateAddMaterialMenuIsOpen} = this.props;
    updateAddMaterialMenuIsOpen(false);
  }

  handleAddMaterialButtonClick() {
    const {updateAddMaterialMenuIsOpen, addMaterialIsOpen} = this.props;
    updateAddMaterialMenuIsOpen(!addMaterialIsOpen);
  }

  handleAddMaterialIconRequestChange(openMenu, eventName) {
    // clicking on the menu trigger is handled by the container's onClick,
    //  only handle closing the menu when the user clicks away here
    if (eventName !== 'clickAway') return;

    const {updateAddMaterialMenuIsOpen} = this.props;
    updateAddMaterialMenuIsOpen(openMenu);
  }

  handleSubjectChange(event, index, value) {
    this.props.setAddPostForm('subjectId', value);
  }

  characterMenuItems() {
    const {characterDropdowns} = this.props;
    if (!characterDropdowns || !characterDropdowns.size) return null;

    return characterDropdowns.map(character =>
      <MenuItem
        key={`character-${character.get('value')}`}
        value={character.get('value')}
        primaryText={character.get('display')} />
    );
  }

  gradeMenuItems(values) {
    const {grades} = this.props;
    if (!grades || !grades.size) return null;

    return grades.map(grade =>
      <MenuItem
        key={`grade-${grade.get('id')}`}
        insetChildren
        checked={values && values.includes(grade.get('id'))}
        value={grade.get('id')}
        primaryText={grade.get('long')} />
    );
  }

  lessonPlanTypeMenuItems() {
    const {lessonPlanTypes} = this.props;
    if (!lessonPlanTypes || !lessonPlanTypes.size) return null;

    return lessonPlanTypes.map(type =>
      <MenuItem
        key={`lesson-type-${type}`}
        value={type.toLowerCase()}
        primaryText={type} />
    );
  }

  materialFileList() {
    return this.materialFiles.map((file, index) =>
      <FileUploader
        key={index}
        fileIndex={index}
        id={`materialFile${index}`}
        fileName={file.name}
        labelText="File"
        accept=".docx, .doc, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"
        onFileSelect={this.handleMaterialFileChange}
        onFileReset={this.handleDeleteMaterialFile} />
    );
  }

  photoList() {
    return this.photos.map((photo, index) =>
      <FileUploader
        key={index}
        fileIndex={index}
        id={`photo${index}`}
        fileName={photo.name}
        labelText="Photo"
        accept="image/png, image/jpeg, .jpeg, .jpg"
        onFileSelect={this.handlePhotoChange}
        onFileReset={this.handleDeletePhoto} />
    );
  }

  materialSupplyList() {
    const {model, updateMaterialSupply, deleteMaterialSupply} = this.props;

    return model.getIn(['materials', 'supplies']).map((supply, index) => {
      // We need these here to access the index
      const updateMaterialSupplyWrapper = (event, text) => updateMaterialSupply(index, text);
      const deleteMaterialSupplyBinder = () => deleteMaterialSupply(index);

      return (
        <div className="material-supply-input-container" key={index}>
          <div className="material-supply-input">
            <TextInput className="material-supply-text-input"
              id={`supply-${index}`}
              value={supply}
              floatingLabelText="Supply"
              onChange={updateMaterialSupplyWrapper} />
          </div>
          <div className="icon-container">
            <Delete className="icon" onClick={deleteMaterialSupplyBinder} />
          </div>
        </div>);
    });
  }

  subjectMenuItems() {
    const {subjects} = this.props;
    if (!subjects || !subjects.size) return null;

    return subjects.map(subject =>
      <MenuItem
        key={`subject-${subject.get('id')}`}
        value={subject.get('id')}
        primaryText={subject.get('name')} />
    );
  }

  render() {
    const {
      addMaterialSupply,
      model,
      onCancel,
      addMaterialIsOpen,
      submitting,
    } = this.props;

    const submitDisabled = !model.get('title') ||
                          !(model.get('characterId') && (model.get('gradeIds').size || model.get('homeCommunity')) || model.get('schoolwide')) ||
                          !model.get('lessonPlanType') ||
                          !model.get('content') ||
                          submitting;

    const featuredFileName = this.featuredImageFile ? this.featuredImageFile.name : '';
    const displayCharacter = !model.get('schoolwide');
    const displayGrade = !model.get('schoolwide') && !model.get('homeCommunity');

    const contentEditorConfig = {
      height: 250,
      paragraphFormat: {
        N: 'Normal',
        H1: 'Heading',
        H2: 'Sub-heading'
      },
      linkList: [],
      placeholderText: 'Content*',
      charCounterCount: false,
      linkAlwaysBlank: true,
    };

    const dividerStyle = {
      marginTop: 10,
      marginBottom: 20,
    };

    const buttonStyle = {
      fontSize: 14,
      fontWeight: 700,
      color: muiTheme.palette.borderColor,
    };

    const addButtonStyle = Object.assign({}, buttonStyle, {
      backgroundColor: muiTheme.palette.primary2Color,
      paddingLeft: 20,
      paddingRight: 20,
    });

    return (
      <div className="add-post-form">
        <Card zDepth={0}>
          <form onSubmit={this.handleSubmitClick}>
            <CardText>
              <div className="component-row">
                <div><small>*Required</small></div>
              </div>
              <div className="component-row">
                <div className="half-component">
                  <div className="home-community-toggle">
                    <Toggle
                      onClick={this.handleHomeCommunityToggle}
                      toggled={model.get('homeCommunity')}
                      labelStyle={{fontSize: 16}}
                      label="Home/Community" />
                  </div>
                </div>
                <div className="half-component">
                  <div className="schoolwide-toggle">
                    <Toggle
                      onClick={this.handleSchoolwideToggle}
                      toggled={model.get('schoolwide')}
                      labelStyle={{fontSize: 16}}
                      label="Schoolwide" />
                  </div>
                </div>
              </div>
              <div>
                <div className="component-row">
                  <div className="half-component title-container">
                    <TextInput
                      fullWidth
                      id="title"
                      value={model.get('title')}
                      floatingLabelText="Title*"
                      onChange={this.handleFieldChange} />
                  </div>
                  <div className="half-component subject-container">
                    <SelectField
                      fullWidth
                      onChange={this.handleSubjectChange}
                      value={model.get('subjectId')}
                      hintText="Subject">
                      {this.subjectMenuItems()}
                    </SelectField>
                  </div>
                </div>
                {displayCharacter || displayGrade
                  ? <div className="component-row">
                    { displayCharacter
                      ? <div className="half-component">
                          <SelectField
                            fullWidth
                            onChange={this.handleCharacterChange}
                            value={model.get('characterId')}
                            hintText="Foundation*">
                            {this.characterMenuItems()}
                          </SelectField>
                        </div>
                        : null
                      }
                    { displayGrade
                      ? <div className="half-component">
                          <SelectField
                            multiple
                            fullWidth
                            onChange={this.handleGradeChange}
                            value={model.get('gradeIds').toJS()}
                            hintText="Grade(s)*">
                            {this.gradeMenuItems(model.get('gradeIds').toJS())}
                          </SelectField>
                        </div>
                      : null
                    }
                  </div>
                  : null
                }
                <div className="component-row">
                  <div className="half-component">
                    <SelectField
                      fullWidth
                      onChange={this.handleLessonPlanTypeChange}
                      value={model.get('lessonPlanType')}
                      hintText="Type*">
                      {this.lessonPlanTypeMenuItems()}
                    </SelectField>
                  </div>
                  <FileUploader
                    className="half-component"
                    id="featuredImage"
                    fileName={featuredFileName}
                    labelText="Featured Image"
                    accept="image/png, image/jpeg, .jpeg"
                    onFileSelect={this.handleFeaturedImageChange}
                    onFileReset={this.handleResetFeaturedImage} />
                </div>
                <div className="component-row">
                  <div className="full-component">
                    <FroalaEditor
                      tag="textarea"
                      config={contentEditorConfig}
                      model={model.get('content')}
                      onModelChange={this.handleContentChange} />
                  </div>
                </div>
                <Divider style={dividerStyle} />
                <div className="component-row">
                  <div className="heavy">Materials</div>
                  <div>
                    <div
                      className="fake-button"
                      onClick={this.handleAddMaterialButtonClick}
                      style={addButtonStyle}>
                      Add Material
                      <IconMenu
                        className="add-material-icon-menu"
                        open={addMaterialIsOpen}
                        onItemTouchTap={this.handleAddMaterialIconTouchTap}
                        onRequestChange={this.handleAddMaterialIconRequestChange}
                        iconButtonElement={<IconButton><ArrowDropDown viewBox="0, -5, 24, 24" className="arrow-icon" /></IconButton>}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                        targetOrigin={{vertical: 'top', horizontal: 'right'}}>
                        <MenuItem onTouchTap={this.handleAddFileMaterial} value="file" primaryText="File" />
                        <MenuItem onTouchTap={addMaterialSupply} value="supply" primaryText="Supply" />
                      </IconMenu>
                    </div>
                  </div>
                </div>
                <div className="half-component-container">
                  {this.materialFileList()}
                  {this.materialSupplyList()}
                </div>
                <Divider style={dividerStyle} />
                <div className="component-row">
                  <div className="heavy">In Action Photos</div>
                  <div>
                    <FlatButton
                      className="raised-button--rounded"
                      onTouchTap={this.handleAddPhoto}
                      style={addButtonStyle}>Add Photo</FlatButton>
                  </div>
                </div>
                <div className="half-component-container">
                  {this.photoList()}
                </div>
              </div>
            </CardText>
            <CardActions className="actions">
              <FlatButton
                style={buttonStyle}
                onTouchTap={onCancel}>Cancel</FlatButton>
              <RaisedButton
                style={buttonStyle}
                className="raised-button--rounded"
                type="submit"
                secondary
                disabled={submitDisabled}>Submit</RaisedButton>
            </CardActions>
          </form>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {addPostForm} = state.features.newCommunityPost.pages;
  return {
    addMaterialIsOpen: addPostForm.get('addMaterialIsOpen'),
    characterDropdowns: addPostForm.get('characterDropdowns'),
    grades: addPostForm.get('grades'),
    lessonPlanTypes: addPostForm.get('lessonPlanTypes'),
    featuredImage: addPostForm.get('featuredImage'),
    submitting: addPostForm.get('submitting'),
    subjects: addPostForm.get('subjects'),
  };
}

AddPostForm.propTypes = {
  addMaterialIsOpen: PropTypes.bool.isRequired,
  addMaterialSupply: PropTypes.func.isRequired,
  characterDropdowns: PropTypes.instanceOf(List).isRequired,
  deleteMaterialSupply: PropTypes.func.isRequired,
  grades: PropTypes.instanceOf(List).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  lessonPlanTypes: PropTypes.instanceOf(List).isRequired,
  loadCharacterDropdowns: PropTypes.func.isRequired,
  loadGrades: PropTypes.func.isRequired,
  loadLessonPlanTypes: PropTypes.func.isRequired,
  loadSubjects: PropTypes.func.isRequired,
  model: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  setAddPostForm: PropTypes.func.isRequired,
  subjects: PropTypes.instanceOf(List).isRequired,
  submitting: PropTypes.bool.isRequired,
  updateAddMaterialMenuIsOpen: PropTypes.func.isRequired,
  updateMaterialFileNames: PropTypes.func.isRequired,
  updateMaterialSupply: PropTypes.func.isRequired,
  updatePhotoNames: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
};

export default withRouter(connect(
  mapStateToProps,
  {
    addMaterialSupply,
    deleteMaterialSupply,
    handleSubmit: submitAddPostForm,
    loadLessonPlanTypes,
    loadCharacterDropdowns,
    loadGrades,
    loadSubjects,
    setAddPostForm,
    updateAddMaterialMenuIsOpen,
    updateMaterialFileNames,
    updateMaterialSupply,
    updatePhotoNames,
  }
)(AddPostForm));



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/components/AddPostForm.js